function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { children, optional, once } from '../Composite';
import Label from '../Label';
import InputArea from '../InputArea';
import InputAreaWithLabelComposite from '../Composite/InputAreaWithLabelComposite/InputAreaWithLabelComposite';

var TextArea = function TextArea(_ref) {
  var props = _objectWithoutProperties(_ref, []),
      children = _ref.children;

  return React.createElement(
    InputAreaWithLabelComposite,
    props,
    children
  );
};

TextArea.propTypes = {
  children: children(optional(Label), once(InputArea))
};

TextArea.displayName = 'TextArea';

export default TextArea;
//# sourceMappingURL=TextArea.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/TextArea/TextArea.js